import dayjs, { Dayjs } from 'dayjs';

export const formatDateToIsoString = (date: string | null | Date | undefined | Dayjs) => {
  return dayjs(date).format('YYYY-MM-DD');
};
